import config from '@/config'

interface State {
  otherMenus: {}
  bankPointTable: {}
  bankDatas: {}
  bitcashPointTable: {}
  ccheckPointTable: {}
  cdirectPointTable: {}
  creditPointTable: {}
  dkouzaPointTable: {}
  dkouzaMeigi: string
  dkouzaTel: string
  recommendedImageURL: string
  appStoreImageURL: string
  googlePlayImageURL: string
  usedCredit: boolean // クレジット決済利用済み？
}

const defaultState: State = {
  otherMenus: {},
  bankPointTable: {},
  bankDatas: {},
  bitcashPointTable: {},
  ccheckPointTable: {},
  cdirectPointTable: {},
  creditPointTable: {},
  dkouzaPointTable: {},
  dkouzaMeigi: '',
  dkouzaTel: '',
  recommendedImageURL: `${config.SERVER_URL}/img/pay/recommend_logo.gif`,
  appStoreImageURL: `${config.SERVER_URL}/img/pay/apple_logo.gif`,
  googlePlayImageURL: `${config.SERVER_URL}/img/pay/google_logo.gif`,
  usedCredit: false
}

const state: State = Object.assign({}, defaultState)

const mutations = {
  resetState(state: State) {
    const s = defaultState
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },

  setOtherMenus(state: State, otherMenus: {}) {
    state.otherMenus = otherMenus
  },
  setBankPointTable(state: State, bankPointTable: {}) {
    state.bankPointTable = bankPointTable
  },
  setBankDatas(state: State, bankDatas: {}) {
    state.bankDatas = bankDatas
  },
  setBitCashPointTable(state: State, bitcashPointTable: {}) {
    state.bitcashPointTable = bitcashPointTable
  },
  setCCheckPointTable(state: State, ccheckPointTable: {}) {
    state.ccheckPointTable = ccheckPointTable
  },
  setCDirectPointTable(state: State, cdirectPointTable: {}) {
    state.cdirectPointTable = cdirectPointTable
  },
  setCreditPointTable(state: State, creditPointTable: {}) {
    state.creditPointTable = creditPointTable
  },
  setDKouzaPointTable(state: State, dkouzaPointTable: {}) {
    state.dkouzaPointTable = dkouzaPointTable
  },
  setDKouzaMeigi(state: State, dkouzaMeigi: string) {
    state.dkouzaMeigi = dkouzaMeigi
  },
  setDKouzaTel(state: State, dkouzaTel: string) {
    state.dkouzaTel = dkouzaTel
  },
  setUsedCredit(state: State, usedCredit: boolean) {
    state.usedCredit = usedCredit
  }
}

const actions = {}

const getters = {
  otherMenus: (state: State): {} => state.otherMenus,
  bankPointTable: (state: State): {} => state.bankPointTable,
  bankDatas: (state: State): {} => state.bankDatas,
  bitcashPointTable: (state: State): {} => state.bitcashPointTable,
  ccheckPointTable: (state: State): {} => state.ccheckPointTable,
  cdirectPointTable: (state: State): {} => state.cdirectPointTable,
  creditPointTable: (state: State): {} => state.creditPointTable,
  dkouzaPointTable: (state: State): {} => state.dkouzaPointTable,
  dkouzaMeigi: (state: State): string => state.dkouzaMeigi,
  dkouzaTel: (state: State): string => state.dkouzaTel,
  recommendedImageURL: (state: State): string => state.recommendedImageURL,
  appStoreImageURL: (state: State): string => state.appStoreImageURL,
  googlePlayImageURL: (state: State): string => state.googlePlayImageURL,
  usedCredit: (state: State): boolean => state.usedCredit
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
